import { render, staticRenderFns } from "./CustomizePanel.vue?vue&type=template&id=7a2eb1d1&scoped=true"
import script from "./CustomizePanel.vue?vue&type=script&lang=js"
export * from "./CustomizePanel.vue?vue&type=script&lang=js"
import style0 from "./CustomizePanel.vue?vue&type=style&index=0&id=7a2eb1d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2eb1d1",
  null
  
)

export default component.exports